import React from 'react';
import { Box } from 'braid-design-system';
import { BlockItemRenderer, blockRenderers } from '../../../renderer';
import type { CarouselItem as CarouselItemType } from '../utils/carouselUtils';

interface CarouselItemProps {
  item: CarouselItemType;
}

export const CarouselItem = React.memo<CarouselItemProps>(({ item }) => (
  <Box position="relative">
    <BlockItemRenderer
      block={item as any}
      renderers={blockRenderers.hirer}
      additionalData={{
        fullURL: '',
        page: { title: '' },
      }}
    />
  </Box>
));

CarouselItem.displayName = 'CarouselItem';
